import { DomApplier } from '../cssFeatures.types'
import { fromClassicCss } from '../../utils/fromClassicCss'
import { SelectorObj } from '../../shared.types'
import { HOVER_DATA_MODE } from '@wix/thunderbolt-commons'

const VISIBLE_STRING = 'visible'

export const hoverBoxCssDomApplier: DomApplier<'hoverBoxCss'> = (
	_compId,
	idSelector, // idSelector is the same as `#${compId}` or '#[id^compId__]' if compId is a repeater
	_breakpointId,
	{ hoverBoxCss }
) => {
	if (!hoverBoxCss) {
		return {}
	}
	const classicCss = fromClassicCss(hoverBoxCss.css, idSelector)
	const isEditorFlow = !!(classicCss[`${HOVER_DATA_MODE} ${idSelector}`] && classicCss[idSelector].height)

	// in order to make sure height isn't chaining between modes that are and aren't visible,
	// we need to make sure that the height is the same.
	if (isEditorFlow) {
		return getCssWithHeights(classicCss, idSelector)
	}
	const { [idSelector]: defaultVisibility, ...rest } = classicCss

	if (defaultVisibility.visibility === 'visible') {
		return rest
	}

	return classicCss
}

const getCssWithHeights = (css: SelectorObj, idSelector: string) => {
	const hoverboxSelector = `${HOVER_DATA_MODE} ${idSelector}`

	const cssWithHeight: SelectorObj = {}
	const hoverSelectorCss = css[hoverboxSelector]
	cssWithHeight[idSelector] = css[idSelector]
	if (cssWithHeight[idSelector].visibility === VISIBLE_STRING) {
		return { [hoverboxSelector]: { ...hoverSelectorCss, height: cssWithHeight[idSelector].height } }
	} else if (hoverSelectorCss.visibility === VISIBLE_STRING) {
		cssWithHeight[idSelector].height = hoverSelectorCss.height
		cssWithHeight[hoverboxSelector] = { visibility: VISIBLE_STRING }
	}
	return cssWithHeight
}
